export const SALESPRO_VIDEO_IDS = ["OVDU8c9UlpQ", "Bmjt1F4LA2M", "VK6GYURdQFI", "pyKoIxPHfCw", "pgV5hHwYEKc", "IzY0z0kX_t8", "OsnNJu4QEac"]

export const PARTNER_VIDEO_IDS = ["6_-n2PeUC00", "0_4XgVTFpLY", "c1Il-4kw3x0", "3IXDTrLBxL8", "RHdrOg0cXB0"]

export const PARTNER_VIDEO_INFO = [
  {
    'name':'Tarun',
    'partner':'Shri Balaji Retail',
    'region':'New Delhi'
  },
  {
    'name':'Ravi Gupta',
    'partner':'R G Cellulars',
    'region':'Kolkata'
  },
  {
    'name':'Avinash Agarwal',
    'partner':'A J Marketing',
    'region':'Kolkata'
  },
  {
    'name':'Srinivas Sadani',
    'partner':'Heartbeat',
    'region':'Kolkata'
  },
  {
    'name':'Nilay Shah',
    'partner':'Mehta Mobile',
    'region':'Ahmedabad'
  }
]